import React from "react";

import useUser from "queryHooks/useUser/useUser";

const Coralogix = () => {
  const { data: userData } = useUser();

  React.useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      return;
    }

    if (typeof window?.dCoralogix?.init === "function" && userData) {
      window.dCoralogix.init({
        application: "msp-ui",
        deploymentId: "0",
        coralogixDomain: "US1",
        user_context: {
          user_email: userData.email,
          user_name: userData.firstName + " " + userData.lastName,
          user_id: userData.globalId,
        },
        labels: {
          customer_domain: userData.email.split("@")[1],
        },
        maskClass: /oui-icon -arrow/g,
        ignoreUrls: [
          new RegExp("^https://fonts.gstatic.com.*"),
          new RegExp("^https://fonts.googleapis.com.*"),
        ],
      });
    }
  }, [userData]);

  return null;
};

export default Coralogix;
